
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ACONF",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ACONF.vue